import "Common/paginator";

const $sort = $("#filter-sort"),
    $fakeSortSelect = $(".js-fake-sort-select");

const changeFakeSortButton = (value) => {
    $fakeSortSelect.val(value);
};

$(function () {
    // fake sort
    const sortValue = $sort.val();

    if (sortValue) {
        changeFakeSortButton(sortValue);
    }

    $fakeSortSelect.on("change", function () {
        const value = $(this).val();

        changeFakeSortButton(value);
        $sort.val(value).trigger("change");
    });
});

Event.on("Listing.fetchedData", function (data) {
    const $listingCount = $(".js-listing-count");

    if ($listingCount.length) {
        $listingCount.each(function () {
            const $countElem = $(this);
            let countHtml = data.count;

            if ($countElem.hasAttr("data-plural")) {
                const listingPlural = $countElem.data("plural");

                countHtml =
                    data.count +
                    " " +
                    Format.plural(listingPlural[0], listingPlural[1], listingPlural[2], data.count);
            }

            if ($countElem.hasAttr("data-template")) {
                countHtml = $countElem.data("template").replace(":value:", countHtml);
            }

            $countElem.html(countHtml);
        });
    }
});
